import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import LanguageContext from "components/LanguageContext";
import Block from "components/templatesComponents/Block";
import { ImageContainer } from "components/templatesComponents/Image";
import SectionTitle from "components/templatesComponents/SectionTitle";
import SeeMoreLink from "components/templatesComponents/SeeMoreLink";
import Tags from "components/templatesComponents/Tags";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";

const DefaultSubTemplate = (props) => {
  const { page = {} } = props;

  const { language } = useContext(LanguageContext);

  return (
    <Block>
      <Grid container spacing={3} sx={{ alignContent: "space-between" }}>
        {page.image && (
          <Grid size={{ xs: 12, lg: 7 }}>
            <ImageContainer ratio={50}>{page.image}</ImageContainer>
          </Grid>
        )}
        <Grid size={{ xs: 12, lg: page.image ? 5 : 12 }}>
          <Stack spacing={2} sx={{ justifyContent: "space-between" }}>
            <SectionTitle>{page.title}</SectionTitle>
            {page.tags && page.tags.length > 0 && <Tags tags={page.tags} noIcon />}
            {page.shortDescription}
            <SeeMoreLink page={page}>{t[language].common.read_more}</SeeMoreLink>
          </Stack>
        </Grid>
      </Grid>
    </Block>
  );
};

DefaultSubTemplate.propTypes = {
  page: PropTypes.shape(),
};

export default DefaultSubTemplate;
